import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
import VueParticles from 'vue-particles'
// 动画 animate.css
import "animate.css";
import vue3TreeOrg from "vue3-tree-org";
import "vue3-tree-org/lib/vue3-tree-org.css";
import commit from './commit'
import i18n from './locales'
import router from './router'
import store from './store'
import { createApp } from 'vue'
import App from './App.vue'
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";

const app = createApp(App);

app.use(Viewer, {
  defaultOptions: {
    inline: false,  //默认值：false。启用内联模式。
    button: true,  //在查看器的右上角显示按钮。
    navbar: true,  //指定导航栏的可见性。
    title: true,  //指定标题的可见性和内容。
    toolbar: true,  //指定工具栏及其按钮的可见性和布局。
    tooltip: true,  //放大或缩小时显示带有图像比率（百分比）的工具提示。
    movable: true,  //启用以移动图像。
    zoomable: true,  //启用以缩放图像
    rotatable: true,  //启用以旋转图像
    scalable: true,  //启用以缩放图像。
    transition: true,  //为某些特殊元素启用CSS3转换。
    fullscreen: true,  //启用以在播放时请求全屏。
    keyboard: true,  //启用键盘支持。
    // url: 'src',  //默认值：'src'。定义获取原始图像URL以供查看的位置。
  },
});
app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(i18n);
app.use(commit);
app.use(VueParticles);
app.use(vue3TreeOrg)
//挂载app
app.mount('#app');

const debounce = (fn, delay) => {
    let timer = null;
    return function () {
      let context = this;
      let args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    }
  }

  const _ResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
      callback = debounce(callback, 16);
      super(callback);
    }
  }
